import {FactoryProvider, ModuleWithProviders, NgModule, Type} from '@angular/core';
import {OauthService} from "./oauth.service";

import {AcsComponent} from "./acs.component";
import {AcsOutComponent} from "./acs-out.component";
import {CommonModule} from "@angular/common";


export class KaliekiAcs {
   static forRoot(whichOauth : Type<OauthService> = OauthService) : ModuleWithProviders{
    return {ngModule: KaliekiAcs, providers: [{provide: OauthService, useClass: whichOauth}]}
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    AcsComponent,
    AcsOutComponent,
  ],
  imports: [CommonModule],
  providers: [OauthService],
  exports: [AcsComponent, AcsOutComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}







interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../src/lib/acs.module.ts